import { useEffect, useState } from 'react';

import { Box, FormControlLabel, Paper, Radio, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

/** API */


/** COMPONENT */
import ModalCustom from 'component/ModalCustom/ModalCustom';
import { colors } from 'constants/theme';


/** CONSTANT */


/** SLICE & UTILS & FEATURES */
import TreatmentApi from 'api/dentists/treatment.api';
import { resetModal } from 'app/slice/modal.slice';
import { selectMe } from 'app/slice/user.slice';
import { swalWarning } from 'component/Alert/Swal';
import { notiSuccess } from 'component/notifications/notifications';
import _ from 'lodash';

/** VARIABLE */


export interface Props {
    isShow: boolean
    viewOnly?: boolean
    onReset?: () => void
    data: any
    patientCaseId: number
}

export function PopupCariesRiskAssessment({ data: cariesRiskAssessmen, patientCaseId, ...props }: Props) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [loading] = useState<boolean>(false)
    const user = useSelector(selectMe)
    const [answers, setAnswers] = useState<Record<string, string>>({
        fluorideReceived: '',
        sugarIntakeFreq: '',
        specialNeeds: '',
        chemoOrRadiation: '',
        dryMouthMed: '',
        cariesPresent: '',
        toothExtraction_3yr: '',
        plaqueVisible: '',
        toothShapeAbnormal: '',
        gumRecession: '',
        foodRetention: '',
        bracesOrDentures: '',
        dryMouthFreq: '',
    });


    useEffect(() => {
        if (cariesRiskAssessmen)
            setAnswers(cariesRiskAssessmen)
        else
            setAnswers({
                fluorideReceived: '',
                sugarIntakeFreq: '',
                specialNeeds: '',
                chemoOrRadiation: '',
                dryMouthMed: '',
                cariesPresent: '',
                toothExtraction_3yr: '',
                plaqueVisible: '',
                toothShapeAbnormal: '',
                gumRecession: '',
                foodRetention: '',
                bracesOrDentures: '',
                dryMouthFreq: '',
            })
    }, [cariesRiskAssessmen])



    /** DATA */
    const [allPrice, setAllPrice] = useState<any>(0)


    const data = [
        { key: '', category: 'ปัจจัยสาเหตุ', question: '', options: [] },
        {
            key: 'fluorideReceived', category: '', question: 'การได้รับฟลูออไรด์ ได้รับ/ไม่ได้รับ (ในแหล่งนํ้าบริโภค ยาสีฟัน การให้ฟลูออไรด์เสริมชนิดต่างๆ)',
            options: [{ value: 'YES', label: t('ได้รับ') }, { value: 'NO', label: t('ไม่ได้รับ') }, { value: '', label: '' }]
        },
        { key: 'sugarIntakeFreq', category: '', question: 'การบริโภคน้ำตาลในอาหารและเครื่องดื่ม และยา (รวมทั้งน้ำผลไม้ น้ำหวาน น้ำอัดลม เครื่องดื่มชูกำลัง และน้ำเชื่อม/ไซรัปในเครื่องดื่มและยา)', options: [{ value: 'LESS_OR_ONLY_MEALS', label: 'บริโภคน้อย หรือเฉพาะมื้ออาหาร' }, { value: 'FREQUENTLY_OR_LONG', label: 'บริโภคบ่อย หรือเป็นเวลานานระหว่างมื้อ' }, { value: '', label: '' }] },
        { key: '', category: 'สุขภาพโดยรวม', question: '', options: [] },
        {
            key: 'specialNeeds',
            category: '',
            question: 'มีความต้องการพิเศษ เช่น มีปัญหาด้านพัฒนาการ ความพิการทางกาย มีปัญหาสุขภาพจิต ใช้สารเสพติด หรือ ความพิการทางสมอง การมองเห็นเลือนรางโรคทางระบบที่เป็น อุปสรรคในการดูแลทำความสะอาดช่องปากได้ด้วยตนเอง หรือ มีผู้ดูแลไม่สามารถดูแลทำความสะอาดช่องปากให้ได้ หรือไม่มีผู้ดูแล',
            options: [{ value: 'NO', label: t('ไม่') }, { value: 'YES', label: t('ใช่') }, { value: 'YES_BUT_CAN_DO_BY_MYSELF', label: t('ใช่ แต่พอดูแลตัวเองได้บ้าง หรือมีผู้ดูแล') }]
        },
        { key: 'chemoOrRadiation', category: '', question: 'มีประวัติได้รับเคมีบำบัด หรือ รังสีรักษา', options: [{ value: 'NO', label: t('ไม่') }, { value: 'YES', label: t('ใช่') }, { value: '', label: '' }] },
        { key: 'dryMouthMed', category: '', question: 'ได้รับยาที่ส่งผลข้างเคียงทำให้น้ำลายน้อย', options: [{ value: 'NO', label: t('ไม่') }, { value: 'YES', label: t('ใช่') }, { value: '', label: '' }] },
        { key: '', category: 'ลักษณะทางคลินิก', question: '', options: [] },
        { key: 'cariesPresent', category: '', question: 'มีฟันผุ (ทั้ง Cavitated และ Non-Cavitated รวมทั้ง White spot หรือ มีวัสดุอุด หรือ ครอบฟันจากปาริชาติฟันผุ)', options: [{ value: 'NOT_HAVE', label: t('ไม่มีรอยโรคฟันผุใหม่ หรือ การอุดฟัน ในช่วง 3 ปีที่ผ่านมา') }, { value: '3Y_NEW', label: t('3++ รอยโรคฟันผุใหม่ หรือ การอุดฟัน ในช่วง 3 ปีที่ผ่านมา') }, { value: 'HAS_BETWEEN_3Y', label: t('1-2 รอยโรคฟันผุใหม่ หรือ การอุดฟัน ในช่วง 3 ปีที่ผ่านมา') }] },
        { key: 'toothExtraction_3yr', category: '', question: 'ถอนฟันเพราะฟันผุในรอบ 3 ปีที่ผ่านมา', options: [{ value: 'NO', label: t('ไม่') }, { value: 'YES', label: t('ใช่') }, { value: '', label: '' }] },
        { key: 'plaqueVisible', category: '', question: 'เห็นคราบจุลินทรีย์ชัดเจน', options: [{ value: 'NO', label: t('ไม่') }, { value: 'YES', label: t('ใช่') }, { value: '', label: '' }] },
        { key: 'toothShapeAbnormal', category: '', question: 'รูปร่างหรือผิวฟันผิดปกติ ทำให้ทำความสะอาดลำบาก', options: [{ value: 'NO', label: t('ไม่') }, { value: 'YES', label: t('ใช่') }, { value: '', label: '' }] },
        { key: 'gumRecession', category: '', question: 'เหงือกร่นรากฟันโผล่', options: [{ value: 'NO', label: t('ไม่') }, { value: 'YES', label: t('ใช่') }, { value: '', label: '' }] },
        { key: 'foodRetention', category: '', question: 'มีเศษอาหารติดตามซอกฟัน จากวัสดุอุดขอบเกิน หรือมีช่องว่าง', options: [{ value: 'NO', label: t('ไม่') }, { value: 'YES', label: t('ใช่') }, { value: '', label: '' }] },
        { key: 'bracesOrDentures', category: '', question: 'จัดฟันทั้งแบบติดแน่นและถอดได้ หรือ มีฟันเทียมบางส่วนชนิดถอดได้', options: [{ value: 'NO', label: t('ไม่') }, { value: 'YES', label: t('ใช่') }, { value: '', label: '' }] },
        { key: 'dryMouthFreq', category: '', question: 'ปากแห้งน้ำลายน้อย หรือรู้สึกว่าปากแห้งบ่อยๆ', options: [{ value: 'NO', label: t('ไม่') }, { value: 'YES', label: t('ใช่') }, { value: '', label: '' }] },
        { key: '', category: '', question: 'สรุปผลการประเมิน', options: ['N/A', '', ''] },
    ];



    const resetForm = async () => {
        dispatch(resetModal())
        if (props.onReset) props.onReset()
    }


    const handleChange = (key: string, value: string) => {

        setAnswers((prev) => ({ ...prev, [key]: value }));
    };



    const handleSubmit = async () => {
        if (!answers.fluorideReceived) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'fluorideReceived' })?.question}"`)
        if (!answers.sugarIntakeFreq) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'sugarIntakeFreq' })?.question}"`)
        if (!answers.specialNeeds) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'specialNeeds' })?.question}"`)
        if (!answers.chemoOrRadiation) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'chemoOrRadiation' })?.question}"`)
        if (!answers.dryMouthMed) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'dryMouthMed' })?.question}"`)
        if (!answers.cariesPresent) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'cariesPresent' })?.question}"`)
        if (!answers.toothExtraction_3yr) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'toothExtraction_3yr' })?.question}"`)
        if (!answers.plaqueVisible) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'plaqueVisible' })?.question}"`)
        if (!answers.toothShapeAbnormal) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'toothShapeAbnormal' })?.question}"`)
        if (!answers.gumRecession) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'gumRecession' })?.question}"`)
        if (!answers.foodRetention) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'foodRetention' })?.question}"`)
        if (!answers.bracesOrDentures) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'bracesOrDentures' })?.question}"`)
        if (!answers.dryMouthFreq) return swalWarning(`กรุณาระบุ "${_.find(data, { key: 'dryMouthFreq' })?.question}"`)

        const resp = await TreatmentApi.updateDentalRiskAssessments(patientCaseId, answers)
        if (resp.status === 201)
            notiSuccess(t('บันทึกแบบประเมินเรียบร้อย'), '', null, () => resetForm())
    }


    return props.isShow ? (

        <ModalCustom
            size={'xl'}
            title={'แบบประเมินความเสี่ยงฟันผุ'}
            alignFooter={'end'}
            fullscreen={'xxl-down'}
            closeButton
            footerInline
            textBtnCancel={props.viewOnly ? t('BUTTON.CLOSE') : t('BUTTON.CANCEL')}
            textBtnConfirm={t('BUTTON.SAVE')}
            onReset={resetForm}
            onSubmit={props.viewOnly ? undefined : handleSubmit}
            modalStyle={'modal-treatment-message'}
            component={
                <>
                    <Box className="pt-1 d-flex flex-column overflow-hidden" sx={{ '*': { color: colors.textPrimary } }}>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableBody>
                                    {data.map((row, rowIndex) => {
                                        return row.category ? <TableRow>
                                            <TableCell sx={{ backgroundColor: rowIndex === 0 ? colors.themeMainColor : '#D7D8DB', }} colSpan={5}>
                                                <Typography color={rowIndex === 0 ? 'white' : 'black'} variant='subtitle1'>{row.category}</Typography>
                                            </TableCell>
                                        </TableRow> :
                                            <TableRow key={rowIndex}>
                                                <TableCell colSpan={2}>{row.question}</TableCell>
                                                {row.options.map((option: any, colIndex) => (
                                                    <TableCell key={colIndex} align="left">
                                                        {option.label &&
                                                            <FormControlLabel

                                                                sx={{ textAlign: 'left' }}
                                                                key={colIndex}
                                                                value={option.value}
                                                                control={
                                                                    <Radio
                                                                        disabled={props.viewOnly}
                                                                        checked={answers[row.key] === option.value}
                                                                        onChange={() => handleChange(row.key, option.value)}
                                                                        value={option.value}
                                                                        name={`radio-${rowIndex}`}
                                                                    />}
                                                                label={option.label}
                                                            />}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                </>
            }
        />
    ) : (
        <></>
    )
}
